<!--
@负责人: 谢汉 
@创建时间: 2019-09-16
@版本:v2.0.10
@描述: 日志分析页-日志统计 重构
-->
<template>
  <div class="logStatistics__content">
    <el-form ref="form" :model="searchForm" :inline="true" input-width="auto">
      <el-form-item>
        <el-dropdown @command="handleDateType" placement="bottom">
          <span class="el-dropdown-link" v-text="dateName"></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="date" v-text="$t('logAnalysis.byDay')"></el-dropdown-item>
            <el-dropdown-item command="month" v-text="$t('logAnalysis.byMonth')"></el-dropdown-item>
            <el-dropdown-item command="year" v-text="$t('logAnalysis.byYear')"></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <el-form-item :label="$t('logAnalysis.time')">
        <el-date-picker
          v-model="searchForm.startTime"
          :type="dateType"
          value-format="timestamp">
        </el-date-picker>
        {{ $t('common.to') }}
        <el-date-picker
          v-model="searchForm.endTime"
          :type="dateType"
          value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('logAnalysis.group')">
        <g-select :list="select_group" v-model="searchForm.groupName"></g-select>
      </el-form-item>
      <el-form-item :label="$t('logAnalysis.app')">
        <g-select :default-all="true" :list="select_app" v-model="searchForm.appName"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchChartData" v-g-rac="gRac('logAnalysisStatistics_search')">{{ $t('common.search') }}</el-button>
      </el-form-item>
    </el-form>
    <div id="logStatisticsChart" :style="chartStyle" v-show="!noData"></div>
    <div v-show="noData" v-text="$t('common.noData')" style="text-align: center;"></div>
  </div>
</template>
<script>
  import LogAnalysisBiz from '@/logic/logRetrieve/logRetrieveBiz'
  import echarts from 'echarts'
  import EventCenter from '@/utils/eventCenter'
  import dic from '@/components/mixins/dic'
  import rac from '@/plugins/rac-mixin'
  const eventCenter = EventCenter()
  export default {
    mixins: [dic, rac],
    components: {
    },
    data () {
      const that = this
      return {
        dateName: this.$t('logAnalysis.byDay'),
        dateType: 'date',
        searchForm: {
          startTime: '',
          endTime: '',
          groupName: '',
          appName: ''
        },
        select_app: {},
        chartInstance: null,
        chartOption: {
          grid: {
            bottom: 60
          },
          tooltip: {},
          legend: {
            data: [this.$t('logAnalysis.awsSize'), this.$t('logAnalysis.localSize'), this.$t('logAnalysis.awsCount'), this.$t('logAnalysis.localCount')]
          },
          xAxis: [
            {
              type: 'category',
              data: [],
              axisPointer: {
                type: 'shadow'
              },
              axisLabel: {
                interval: 0
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: this.$t('logAnalysis.size'),
              axisLabel: { // 换算单位 原单位是BYTE
                formatter: function (value, index) {
                  let dataObj = that.getUnit('BYTE', value)
                  return `${dataObj['data']} ${dataObj['unit']}`
                }
              }
            },
            {
              type: 'value',
              name: this.$t('logAnalysis.count')
            }
          ],
          series: [
            {
              name: this.$t('logAnalysis.awsSize'),
              type: 'line',
              data: [],
              tooltip: { // 换算单位 原单位是BYTE
                formatter: function (params) {
                  let result = `${params.seriesName}</br>${params.marker}${params.name}: ${that.getUnit('BYTE', params.value)['data']}${that.getUnit('BYTE', params.value)['unit']}`
                  return result
                }
              }
            },
            {
              name: this.$t('logAnalysis.localSize'),
              type: 'line',
              data: [],
              tooltip: { // 换算单位 原单位是BYTE
                formatter: function (params) {
                  let result = `${params.seriesName}</br>${params.marker}${params.name}: ${that.getUnit('BYTE', params.value)['data']}${that.getUnit('BYTE', params.value)['unit']}`
                  return result
                }
              }
            },
            {
              name: this.$t('logAnalysis.awsCount'),
              type: 'bar',
              barMaxWidth: 30,
              yAxisIndex: 1,
              data: []
            },
            {
              name: this.$t('logAnalysis.localCount'),
              type: 'bar',
              barMaxWidth: 30,
              yAxisIndex: 1,
              data: []
            }
          ]
        },
        chartStyle: {
          width: '600px',
          height: '400px'
        },
        noData: false,
        select_group: {}
      }
    },
    computed: {
    },
    props: {
      tabName: {
        type: String
      }
    },
    methods: {
      getUnit (unit, data) {
        const unitArr = ['BYTE', 'KB', 'MB', 'GB', 'TB']
        const newUnit = unitArr.indexOf(unit) !== -1 ? unit : unitArr[0]
        if (newUnit === 'TB') {
          return {
            unit: newUnit,
            data: data
          }
        } else if (data > 1024) {
          const index = unitArr.indexOf(newUnit) + 1
          data = (data / 1024).toFixed(2)
          return this.getUnit(unitArr[index], data)
        } else {
          return {
            unit: newUnit,
            data: data
          }
        }
      },
      calMax (arr) {
        let max = 0
        arr.forEach((el) => {
          el.forEach((el1) => {
            if (!(el1 === undefined || el1 === '')) {
              if (max < el1) {
                max = el1
              }
            }
          })
        })
        let maxint = Math.ceil(max / 9.5) // 不让最高的值超过最上面的刻度
        let maxval = maxint * 10 // 让显示的刻度是整数
        return maxval
      },
      calMin (arr) {
        let min = 0
        arr.forEach((el) => {
          el.forEach((el1) => {
            if (!(el1 === undefined || el1 === '')) {
              if (min > el1) {
                min = el1
              }
            }
          })
        })
        let minint = Math.floor(min / 10)
        let minval = minint * 10 // 让显示的刻度是整数
        return minval
      },
      async waitGroupList () {
        await this.dGetGroup()
        this.select_group = this.$store.state.dicModule.group
        this.searchForm.groupName = Object.keys(this.select_group)[0]
      },
      async waitAppList (group) {
        await this.dGetAppByGroup('', group)
        this.select_app = { ...this.dDictionaryApp[group] }
        this.searchForm.appName = ''
      },
      handleDateType (command) {
        this.dateType = command
        switch (command) {
          case 'date':
            this.dateName = this.$t('logAnalysis.byDay')
            this.searchForm.startTime = new Date().setTime(new Date(new Date().getFullYear(), new Date().getMonth()))
            this.searchForm.endTime = new Date().setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()))
            break
          case 'month':
            this.dateName = this.$t('logAnalysis.byMonth')
            this.searchForm.startTime = new Date().setTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1))
            this.searchForm.endTime = new Date().setTime(new Date(new Date().getFullYear(), new Date().getMonth()))
            break
          case 'year':
            this.dateName = this.$t('logAnalysis.byYear')
            this.searchForm.startTime = new Date().setTime(new Date(new Date().getFullYear() - 1, 0))
            this.searchForm.endTime = new Date().setTime(new Date(new Date().getFullYear(), 0))
            break
          default:
        }
      },
      setChartInstance () {
        this.chartInstance = echarts.init(document.getElementById('logStatisticsChart'))
      },
      resize () {
        if (this.chartInstance && !this.chartInstance.isDisposed()) {
          this.chartInstance.resize()
        }
      },
      setChartStyle () {
        this.chartStyle.width = document.getElementsByClassName('tabView')[0].clientWidth - 66 + 'px'
        this.chartStyle.height = document.getElementsByClassName('tabView')[0].clientHeight - 230 + 'px'
      },
      resizeEvent () {
        this.setChartStyle()
        this.$nextTick(() => {
          this.resize()
        })
      },
      setResize () {
        this.resizeEvent()
        eventCenter.addResizeEvent('logStatisticsChart', () => {
          this.resizeEvent()
        })
      },
      searchChartData () {
        if (this.searchForm.endTime <= this.searchForm.startTime) {
          this.$message({
            message: this.$t('ITDeviceMonitor.timeAlert'),
            type: 'warning'
          })
          return
        }
        let dateType = 'D'
        // 按天：最多支持查询31天
        // 按月：最多支持查询36个月
        // 按年：最多支持查询12年
        if (this.dateType === 'date') {
          dateType = 'D'
          if ((this.searchForm.endTime - this.searchForm.startTime) / 86400000 > 31) {
            this.$message({
              message: this.$t('logAnalysis.searchDateTips'),
              type: 'warning'
            })
            return
          }
        } else if (this.dateType === 'month') {
          let endTime = this.searchForm.endTime
          let startTime = this.searchForm.startTime
          if ((new Date(endTime).getFullYear() - new Date(startTime).getFullYear()) > 3 ||
            ((new Date(endTime).getFullYear() - new Date(startTime).getFullYear()) === 3 &&
            (new Date(endTime).getMonth() - new Date(startTime).getMonth()) > 0)) {
            this.$message({
              message: this.$t('logAnalysis.searchMonthTips'),
              type: 'warning'
            })
            return
          }
          dateType = 'M'
        } else if (this.dateType === 'year') {
          if ((new Date(this.searchForm.endTime).getFullYear() - new Date(this.searchForm.startTime).getFullYear()) > 12) {
            this.$message({
              message: this.$t('logAnalysis.searchYearTips'),
              type: 'warning'
            })
            return
          }
          dateType = 'Y'
        }
        LogAnalysisBiz.metricLogs({ ...this.searchForm, type: dateType }).then((data) => {
          if (data && data.extra && data.extra.length > 0) {
            this.noData = false
            let chartTime = []
            let awsCount = []
            let awsSize = []
            let localCount = []
            let localSize = []
            data.extra.map(item => {
              chartTime.push(item.date)
              awsCount.push(item.local_cnt)
              awsSize.push(item.local_size)
            })
            data.local.map(item => {
              localCount.push(item.local_cnt)
              localSize.push(item.local_size)
            })
            this.chartOption.xAxis[0].data = chartTime
            this.chartOption.series[0].data = awsSize
            this.chartOption.series[1].data = localSize
            this.chartOption.series[2].data = awsCount
            this.chartOption.series[3].data = localCount
            // 防止两条Y轴不对齐
            let sizeMin = this.calMin([awsSize, localSize])
            let sizeMax = this.calMax([awsSize, localSize])
            let countMin = this.calMin([awsCount, localCount])
            let countMax = this.calMax([awsCount, localCount])
            this.chartOption.yAxis[0].min = sizeMin
            this.chartOption.yAxis[0].max = sizeMax
            this.chartOption.yAxis[1].min = countMin
            this.chartOption.yAxis[1].max = countMax
            this.chartOption.yAxis[0].splitNumber = 5
            this.chartOption.yAxis[1].splitNumber = 5
            this.chartOption.yAxis[0].interval = (sizeMax - sizeMin) / 5
            this.chartOption.yAxis[1].interval = (countMax - countMin) / 5
            this.chartInstance.setOption(this.chartOption)
            this.setResize()
          } else {
            this.noData = true
          }
        })
      }
    },
    watch: {
      'searchForm.groupName' () {
        this.waitAppList(this.searchForm.groupName)
      },
      $route (to, from) {
        if (to.name === 'logAnalysis' && this.tabName === this.$t('logAnalysis.logStatistics')) {
          this.setResize()
        } else if (from.name === 'logAnalysis' && this.tabName === this.$t('logAnalysis.logStatistics')) {
          eventCenter.removeResizeEvent('logStatisticsChart')
        }
      },
      tabName (val) {
        if (val === this.$t('logAnalysis.logStatistics') && !this.chartInstance) {
          this.searchForm.startTime = new Date().setTime(new Date(new Date().getFullYear(), new Date().getMonth()))
          this.searchForm.endTime = new Date().setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()))
          this.waitGroupList()
          this.setChartStyle()
          this.setChartInstance()
          this.setResize()
        } else if (val !== this.$t('logAnalysis.logStatistics') && this.chartInstance) {
          eventCenter.removeResizeEvent('logStatisticsChart')
        } else if (val === this.$t('logAnalysis.logStatistics') && this.chartInstance) {
          this.setResize()
        }
      }
    },
    mounted () {
    }
  }
</script>
<style scoped>
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
       